import { render } from "./InputMain.vue?vue&type=template&id=5cd10766&scoped=true"
import script from "./InputMain.vue?vue&type=script&lang=js"
export * from "./InputMain.vue?vue&type=script&lang=js"

import "./InputMain.vue?vue&type=style&index=0&id=5cd10766&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd10766"]])

export default __exports__